<div id="todo" class="page-layout simple fullwidth docs left-sidebar">

    <fuse-sidebar class="sidebar" name="product-main-sidebar" position="left" lockedOpen="gt-md">
        <product-main-sidebar></product-main-sidebar>
    </fuse-sidebar>

    <div class="center">
        <selling-navbar></selling-navbar>

        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
            <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                  fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                <div class="h2 mb-24">{{'Product data'|translate}}</div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                        <mat-label>{{'Name'|translate}}</mat-label>
                        <input matInput formControlName="name" required>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>{{'Name is required!'|translate}}</mat-error>
                    </mat-form-field>

                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="80" class="pr-4">
                        <mat-label>{{'Name for receipt'|translate}}</mat-label>
                        <input matInput formControlName="nameForReceipt" required>

                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>{{'Name for receipt is required!'|translate}}</mat-error>
                    </mat-form-field><br/>
                    <div fxFlex="20" fxLayout="row">
                        {{ 'Length'|translate }}:
                        {{ form.get('nameForReceipt').value.length }}
                    </div>

                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-checkbox formControlName="product" fxFlex="100">
                        <mat-label>{{'Is product'|translate}}</mat-label>
                    </mat-checkbox>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-checkbox formControlName="material" fxFlex="100">
                        <mat-label>{{'Is material'|translate}}</mat-label>
                    </mat-checkbox>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="80">
                        <mat-label>{{'Category'|translate}}</mat-label>
                        <mat-select formControlName="category">
                            <mat-option [value]="category.id" *ngFor="let category of categories">
                                {{category.name}}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                    </mat-form-field>
                    <div fxFlex="20">
                        <a mat-raised-button color="primary" (click)="addCategory()">{{'Add category'|translate}}</a>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="80">
                        <mat-label>{{'Manufacturer'|translate}}</mat-label>
                        <mat-select formControlName="manufacturer">
                            <mat-option [value]="manufacturer.id" *ngFor="let manufacturer of manufacturers">
                                {{manufacturer.name}}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                    </mat-form-field>
                    <div fxFlex="20">
                        <a mat-raised-button color="primary" (click)="addManufacturer()">{{'Add manufacturer'|translate}}</a>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="33" class="pr-4">
                        <mat-label>{{'Price net'|translate}}</mat-label>
                        <input matInput formControlName="priceNet">
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="33">
                        <mat-label>{{'Vat rate'|translate}}</mat-label>
                        <mat-select formControlName="vatRate">
                            <mat-option [value]="vatRate.id" *ngFor="let vatRate of vatRates">
                                {{vatRate.vatName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="33" class="pr-4">
                        <mat-label>{{'Price gross'|translate}}</mat-label>
                        <input matInput formControlName="priceGross">
                    </mat-form-field>

                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="33" class="pr-4">
                        <mat-label>{{'Minimal stock'|translate}}</mat-label>
                        <input matInput formControlName="minimalStock">
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="33">
                        <mat-label>{{'Unit'|translate}}</mat-label>
                        <mat-select formControlName="unit">
                            <mat-option [value]="unit.id" *ngFor="let unit of units">
                                {{unit.name}}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                    </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="33" class="pr-4">
                        <mat-label>{{'Purchase price gross'|translate}}</mat-label>
                        <input matInput formControlName="purchasePriceGross">
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="33" class="pr-4">
                        <mat-label>{{'Purchase price net'|translate}}</mat-label>
                        <input matInput formControlName="purchasePriceNet">
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    </mat-form-field>

                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="33" class="pr-4">
                        <mat-label>{{'Barcode'|translate}}</mat-label>
                        <input matInput formControlName="barcode">
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    </mat-form-field>

                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="100">
                        <mat-label>{{'Description'|translate}}</mat-label>
                        <textarea matInput formControlName="description"></textarea>
                    </mat-form-field>
                </div>


                <input type="file" multiple (change)="onFileChange($event)"/>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button mat-raised-button type="submit" color="accent">
                            {{'Save'|translate}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
